import styled from "styled-components";
import { theme } from "../theme/toyotaTheme";
import { getBreakpoint } from "../../../../themes/common";

export const Wrapper = styled.span`
    display: grid;
    padding: 40px 80px;
    text-transform: none !important;
    background-color: ${theme.colors.grey2};
    grid-template-columns: 240px 1fr;
    grid-gap: ${theme.space[5]}px;
    @media ${getBreakpoint("down", "xl")} {
        grid-template-columns: minmax(0, 1fr);
        row-gap: 30px;
    }
`;

export const Subtitle = styled.h3`
    font-family: ${theme.fonts.semiBold};
    font-size: 2rem;
    font-weight: 400;
    line-height: 1.2;
    text-transform: none;
`;

export const QrCode = styled.div`
    display: flex;
    flex-direction: column;
    justify-self: center;
    align-items: center;
    width: fit-content;
    padding: ${theme.space[4]}px;
    background-color: ${theme.colors.primaryWhite};
    border-radius: 12px;
    box-shadow: 0px 0px 8px 0px ${theme.colors.transparancyDark25};
`;

export const Cards = styled.div`
    display: flex;
    width: 100%;
    gap: ${theme.space[4]}px;

    @supports not (gap: 0) {
        & > div:not(:only-child):not(:nth-last-child(1)) {
            margin-right: ${theme.space[4]}px;
        }
    }

    @media ${getBreakpoint("down", "xl")} {
        flex-direction: column;
    }
`;

export const InfoCard = styled.div`
    flex-grow: 1;
    padding: ${theme.space[3]}px ${theme.space[4]}px;
    background-color: ${theme.colors.primaryWhite};
`;

export const NumberIcon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    text-align: center;
    color: ${theme.colors.primaryWhite};
    background-color: ${theme.colors.primaryBlack};
    border-radius: 50%;
`;

export const Icons = styled.div`
    display: flex;
    align-items: center;
    min-height: 80px;
`;

export const SvgWrapper = styled.span`
    width: 80px;
    margin-left: auto;
`;

export const Title = styled.div`
    margin-bottom: ${theme.space[2]}px;
    font-family: ${theme.fonts.semiBold};
    font-size: 2rem;
    line-height: 2.8rem;
`;

export const Label = styled.p`
    margin-top: ${theme.space[2]}px;
    font-family: ${theme.fonts.semiBold};
    font-size: 1.6rem;
`;
